var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jf-table-view',{ref:"tableView",attrs:{"options":_vm.tableOptions}},[_vm._t("external-filters",null,{"slot":"external-filters"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }